import axios from './axiosConfig';
import { deleteAllCookies } from '../helpers/cookie.helper';
import { convertToFormData } from '../helpers/index.helper';

export const encryptEmail = async (email) => {
    try {
        const response = await axios.get(`/api/User/EncryptResetPasswordLink`, { params: { email } });
        if (response.data) {
            return response.data;
        }
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const changePassword = async (data) => {
    try {
        const response = await axios.post(`/api/User/ResetPasswordLink`, convertToFormData(data));
        if (response.data) {
            localStorage.clear();
            sessionStorage.clear();
            deleteAllCookies();
            return response.data;
        }
    } catch (err) {
        console.log(err);
        throw err;
    }
}